import React, {useCallback, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Card from "components/PurpleTheme/Card";
import "./style.scss"
import {
  clearRcaData,
  deleteRcaById,
  getAlertLogs,
  getRca,
  getRcaById,
  getServices,
  getUsers,
  postFullRca,
  updateRcaActions,
  updateRcaHeaderDetails,
  updateRcaImpact,
  updateRcaImpactedApplications,
  updateRcaIncidentDetails,
  updateRcaQuestions,
  updateRcaRelatedAlerts,
  updateRcaRelatedRcas,
  updateRcaTimeline,
} from "store/actions";
import Select from 'react-select';

import * as Yup from "yup";
import {useFormik} from "formik";
import ShareModal from "components/Rca/ShareModal";
import CardItem from "components/PurpleTheme/CardItem";
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Popover,
  PopoverBody,
  Row,
  UncontrolledTooltip
} from "reactstrap";
import moment from "moment";
import Editor from './Editor';
import CardHeader from "../../components/PurpleTheme/CardHeader";
import {getIntegrationLogo} from "../../helpers/component_helpers";
import { useLocation } from 'react-router-dom';
const selectUsers = state => state.Organization.users || [];

const RcaForm = () => {
  const dispatch = useDispatch();
  const { rcaId } = useParams();
  const [ editMode, setEditMode ] = useState(false);
  const [ dataToSubmit, setDataToSubmit ] = useState({});
  const [ dataToEdit, setDataToEdit ] = useState({})
  const [ viewSidebar, setViewSideBar ] = useState(true);
  const [ status, setStatus ] = useState(null);
  const [ isEditable, setIsEditable ] =
    useState(
      {
        impact: false,
        timeline: false,
        action_items: false,
        incident: true,
        header: false,
        questions: false,
        related_alerts: false,
        related_rcas: false,
        impacted_applications: false
      });
  const [loading, setLoading] =
    useState(
      {
        impact: false,
        timeline: false,
        header: false,
        action_items: false,
        questions: false,
        related_alerts: false,
        related_rcas: false,
        impacted_applications: false
      });
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const usersState = useSelector(selectUsers);
  const [ selectedService, setSelectedService ] = useState(null);
  const [ alertsToSelect, setAlertsToSelect ] = useState([]);
  const [ RcasToSelect, setRcasToSelect ] = useState([]);
  const [ allAlerts, setAllAlerts ] = useState({});
  const [ searchQueryAlerts, setSearchQueryAlerts ] = useState('');
  const [ searchQueryRca, setSearchQueryRca ] = useState('');
  const [ searchQueryOwner, setSearchQueryOwner ] = useState('');
  const [ searchQueryReviewer, setSearchQueryReviewer ] = useState('');
  const [ allUsers, setAllUsers ] = useState('');
  const [openAddActionItems, setOpenAddActionItems] = useState(true);
  const [enableEditOnCreate, setEnableEditOnCreate] = useState(true);
  const getDefaultTargetDate = () => {
    const oneWeekFromNow = new Date();
    oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);
    return oneWeekFromNow.toISOString().split('T')[0];
  };
  const [actionItems, setActionItems] = useState(() => ({
    short_term_actions: [],
    long_term_actions: [],
    all: [],
  }));
  const [actionItem, setActionItem] = useState([
    {
      id: 0,
      title: '',
      target_date: getDefaultTargetDate(),
      assigned_to: '',
      description: '',
      position : 0 ,
      label: 'ShortTermFix',
      status: 'Pending'
    }
  ]);
  const [ allImages, setAllImages ] =  useState({impact:[]});
  const [ questions, setQuestions ] = useState([{question: '', response: '', images: []}]);
  const [events, setEvents] = useState([
    { date: '', time: '', event: '', timestamp:'', images:[], event_timezone: ''},
  ]);
  const [ allRcas, setAllRcas ] = useState({});
  const [ serviceOptions, setServiceOptions ] = useState([]);
  const [ selectedServices, setSelectedServices ] = useState([]);

  const [ actionItemIsOpen, setActionItemIsOpen ] = useState(false);
  const [ shareModalIsOpen, setShareModalIsOpen ] = useState(false);
  const [deleteConfirmationModalIsOpen, setDeleteConfirmationModalIsOpen] = useState(false);

  const [enableEdit,setEnableEdit] = useState(false);

  const { services } = useSelector(state => ({
    services: state.Service.services
  }));

  const { alerts } = useSelector(state => ({ alerts: state.AlertLog.alerts }));

  const { users } = useSelector(state => ({ users: state.Organization.users || []}));

  const { rcas } = useSelector(state => ({rcas: state.Rca.rcas}));

  const { rca_by_id } = useSelector(state => ({rca_by_id: state.Rca.rca_by_id}));

  const currentUserId = localStorage.getItem("user_id");

  const statusOptions = [
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed"},
    { value: "ShortTermFixPending", label: "ShortTermFixPending"},
    { value: "LongTermFixPending", label: "LongTermFixPending"}
  ]

  const toggleActionItemSection = () => {
    setOpenAddActionItems(!openAddActionItems);
  };

  useEffect(() => {
    dispatch(getRca())
  }, [dispatch]);

  useEffect(() => {
    let pageFilters = {
      'page': 1,
      'limit': 1000,
      'filter_type':"RCA"
    }
    dispatch(getRca(pageFilters))

  }, [getRca, dispatch]);

  const location = useLocation();
  const alert_list = location?.state?.alert_list;

  useEffect(() => {
    setTimeout(() => {
      if(alert_list?.length > 0){
        const formattedAlerts = alert_list?.map(item => ({
          id: item?.id,
          name: item?.name,
          resource_name: item?.resource_name,
          metric_name: item?.metric_name,
          opened_at: item?.opened_at,
          closed_at: item?.closed_at,
          integration_type: item?.integration_type,
          application_service_id: item?.application_service_id,
          application_service_name: item?.application_service?.name
        }));

        setAlertsToSelect(formattedAlerts);
        let data = { ...dataToSubmit };
        if (!Array.isArray(data.related_alerts)) {
          data.related_alerts = [];
        }
        formattedAlerts.forEach(x =>  data.related_alerts.push({ alert_log_id: x.id }))
        setDataToSubmit(data);

        validation.values.title = alert_list[0]?.name;
        const appServices = [];
        const uniqueServiceIds = new Set();

        formattedAlerts.forEach(x => {
          if (!uniqueServiceIds.has(x?.application_service_id)) {
            uniqueServiceIds.add(x?.application_service_id);
            appServices.push({
              application_service_id: x?.application_service_id,
              name: x?.application_service_name,
            });
          }
        });
        setSelectedServices(appServices);
      }
    },200)
  }, []);

  useEffect(() => {
    if(rcaId){
      setEnableEditOnCreate(false)
    }
  }, [rcaId]);

  const formatTimeForStorage = (timeStr) => {
    // function for sending time in the right format just before creating or updating. format : HH:MM
    if (!timeStr) return '';

    try {
      const [hours, minutes] = timeStr.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    } catch (error) {
      console.error('Error formatting time for storage:', error);
      return '';
    }
  };

  const extractTime = (timestamp) => {
    //function for extracting time from timestamp to display time field for created RCA's
    if (!timestamp) return '';

    try {
      const [, timeStr] = timestamp.split(' ');
      if (!timeStr) return '';

      // Return time in 24-hour format for the input
      const [hours, minutes] = timeStr.split(':');
      if (!hours || !minutes) return '';

      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    } catch (error) {
      console.error('Error extracting time:', error);
      return '';
    }
  };

  useEffect(() => {
    if(rcaId && rca_by_id?.rca?.reviewer){
      validation.values.reviewer = allUsers[rca_by_id?.rca?.reviewer]?.name
    }
    if(rcaId && rca_by_id?.rca?.owner){
      validation.values.owner = allUsers[rca_by_id?.rca?.owner]?.name
    }
    if(rcaId && rca_by_id?.rca?.status){
      validation.values.status = rca_by_id?.rca?.status
    }
    if (rcaId && rca_by_id?.action_items) {
      const formattedActionItems = {
        short_term_actions: [],
        long_term_actions: [],
        all: []
      };

      rca_by_id.action_items.forEach(item => {
        const actionItemInfo = {
          title: item.title,
          target_date: item.target_date,
          assigned_to: item.assigned_to,
          label: item.type,
          status: item.status,
          rca_action_id: item.id,
          description: item.description
        };

        if (item.type === "ShortTermFix") {
          formattedActionItems.short_term_actions.push(actionItemInfo);
        } else if (item.type === "LongTermFix") {
          formattedActionItems.long_term_actions.push(actionItemInfo);
        }
        formattedActionItems.all.push(actionItemInfo);

      });
      setActionItem(formattedActionItems.all)
      setActionItems(formattedActionItems);
    }

    if (rcaId && rca_by_id?.related_past_rcas) {
      const formattedRcas = rca_by_id.related_past_rcas.map(rca => ({
        id: rca.related_rca.id,
        title: rca.related_rca.title,
        status: rca.related_rca.status,
        updated_at: rca.updated_at,
        created_by: rca.created_by,
        updated_by: rca.updated_by,
        owner: rca.related_rca.owner,
        reviewer: rca.related_rca.reviewer,
      }));
      setRcasToSelect(formattedRcas);
    }

    if (rcaId && rca_by_id?.related_alerts) {
      const formattedAlerts = rca_by_id.related_alerts.map(item => ({
        id: item.alert_log.id,
        name: item.alert_log.name,
        resource_name: item.alert_log.resource_name,
        metric_name: item.alert_log.metric_name,
        opened_at: item.alert_log.opened_at,
        closed_at: item.alert_log.closed_at,
        integration_type: item.alert_log.integration_type,
        application_service_id: item.alert_log.application_service_id,
        application_service_name: item.alert_log.application_service?.name
      }));
      setAlertsToSelect(formattedAlerts);
    }

    if (rcaId && rca_by_id.impacted_application_services) {
      const formattedServices = rca_by_id.impacted_application_services.map(service => ({
        name: service.application_service.name,
        application_service_id: service.application_service.id
      }));
      setSelectedServices(formattedServices);
    }

    if (rcaId && rca_by_id.questions) {
      const question_images = rca_by_id.question_images?.rcaId?.map(item => ({
        previewUrl: item.image_url,
        name: item.id,
        position: item.position
      })) || [];

      const formattedQuestions = rca_by_id.questions.map(item => ({
        rca_question_id: item.id,
        question: item.question,
        response: item.response,
        images: question_images
      }));

      setQuestions(formattedQuestions);
    }
    if (rcaId &&  rca_by_id.rca_timelines) {
      const timeline_images = rca_by_id.timeline_images?.rcaId?.map(item => ({
        previewUrl: item.image_url,
        name: item.id,
        position: item.position
      })) || [];

      const formattedEvents = rca_by_id.rca_timelines.map(item => ({
        rca_timeline_id: item.id,
        date: getDate1(item.timestamp),
        time: getTime(item.timestamp),
        timestamp: formatTimeForInput(item.timestamp),
        event: item.event,
        images: timeline_images,
        event_timezone: item.event_timezone,
      }));

      setEvents(formattedEvents);
    }
    if(rcaId && rca_by_id.impact){
      validation.values.impact_desc = rca_by_id?.impact?.description;
    }
    if(rca_by_id.impact === null){
      validation.values.impact_desc = ""
    }
    if(rcaId && rca_by_id?.rca?.description){
      validation.values.incidentDesc = rca_by_id.rca.description
    }
    if(rca_by_id?.rca?.description === null){
      validation.values.incidentDesc = ""
    }
    if(rcaId && rca_by_id?.rca?.title){
      validation.values.title = rca_by_id?.rca?.title
    }
  }, [rca_by_id, rcaId, enableEdit]);

  useEffect(() => {
    if (!rcaId) {
      resetFormStates();
    }
  }, [rca_by_id]);

  useEffect(() => {
    dispatch(clearRcaData());
    resetFormStates();
    if(rcaId){
      toggleActionItemSection(true);
      dispatch(getRcaById(rcaId))

    } else {
      setEditMode(true)
      setIsEditable( {
        impact: true,
        timeline: true,
        action_items: true,
        questions: true,
        related_alerts: true,
        related_rcas: true,
        impacted_applications: true

      })
    }
  }, [dispatch, rcaId])

  useEffect(() => {
    if(enableEdit && questions.length === 0){
      setQuestions([{
        question: '',
        response: '',
        images: []
      }]);
    }
    if(enableEdit && events.length === 0){
      setEvents( [{
        date: '',
        time: '',
        event: '',
        timestamp: '',
        images: [],
        event_timezone: '',
      }]);
    }
  }, [enableEdit]);

  useEffect(() => {
    dispatch(getAlertLogs({page:1, limitPerPage:100}));
    dispatch(getRca());
    dispatch(getServices())
    dispatch(getUsers())
  }, [getAlertLogs, getRca, getServices, getUsers])


  useEffect(() => {
    const updatedAlerts = {};

    alerts.forEach((item) => {
      updatedAlerts[item.id] = {
        id: item.id,
        name: item.name,
        resource_name: item.resource_name,
        metric_name: item.metric_name,
        opened_at: item.opened_at,
        application_service_id : item.application_service.id,
        application_service_name : item.application_service.name
      };
    });

    setAllAlerts(updatedAlerts);
  }, [alerts]);

  useEffect(() => {
    const options = services?.map((service) => ({
      value: service.id,
      label: service.name
    }));
    setServiceOptions(options);
  }, [services])

  useEffect(() => {
    const updatedRca = {}
    rcas?.rca?.forEach((item) => {
      updatedRca[item.rca.id] = {
        id: item.rca.id,
        title: item.rca.title,
        status: item.rca.status,
        updated_at: item.rca.updated_at,
        updated_by: item.rca.updated_by,
        created_by: item.rca.created_by
      }
    })
    setAllRcas(updatedRca);
  }, [rcas])


  useEffect(() => {
    if (usersState && usersState.length > 0) {
      const updatedUsers = {};
      usersState.forEach((item) => {
        updatedUsers[item.id] = {
          id: item.id,
          name: item.name,
        };
      });
      setAllUsers(updatedUsers);
    }
  }, [usersState.length, getUsers, dispatch, actionItemIsOpen, getRca]);

  useEffect(() => {
    if (rcaId && isEditable.action_items) {
      setOpenAddActionItems(false);
    }
  }, [rcaId, isEditable.action_items]);

  const toggleActionItemModal = useCallback(() => {
    setActionItemIsOpen(prev => !prev);
  }, []);

  const toggleShareModal = () => setShareModalIsOpen(!shareModalIsOpen);

  const getDate1 = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp); // Parse the timestamp
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const getDate = (timestamp) => {
    const timestampObj = new Date(timestamp);
    return timestampObj.toLocaleDateString('en-GB', {timeZone: 'UTC'});
  };
  const formatDateForDisplay = (timestamp, includeYear = false) => {
    if (!timestamp) return '';

    try {
      const [datePart] = timestamp.split(' ');
      const [day, month, year] = datePart.split('-');

      if (!day || !month || !year) return '';
      return includeYear
          ? `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
          : `${day.padStart(2, '0')}/${month.padStart(2, '0')}`;
    } catch (error) {
      console.error('Error formatting date for display:', error);
      return '';
    }
  };

  const formatDateForInput = (timestamp) => {
    if (!timestamp) return '';

    try {
      const [datePart] = timestamp.split(' ');
      const [day, month, year] = datePart.split('-');
      if (!day || !month || !year) return '';
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    } catch (error) {
      console.error('Error formatting date for input:', error);
      return '';
    }
  };
  const getTime = (timestamp) => {
    const timestampObj = new Date(timestamp);
    const hours = String(timestampObj.getHours()).padStart(2, '0'); // Get hours in 24-hour format
    const minutes = String(timestampObj.getMinutes()).padStart(2, '0'); // Get minutes
    return `${hours}:${minutes}`;
  };

  const filteredAlerts = Object.entries(allAlerts).filter(([id, alert]) => {
    const isAlreadySelected = alertsToSelect.some((selectedAlert) => selectedAlert.id === id);
    return (
        !isAlreadySelected &&
        alert.name.toLowerCase().includes(searchQueryAlerts.toLowerCase())
    );
  });

  const filteredRcas = Object.entries(allRcas).filter(([id, rca]) => {
    const isRcaSelected = RcasToSelect.some((selectedRcas) => selectedRcas.id === id);
    return (
        !isRcaSelected &&
        rca.title.toLowerCase().includes(searchQueryRca.toLowerCase())
    );
  });

  const addAlerts = (alert) => {
    let data = { ...dataToSubmit };
    if (!Array.isArray(data.related_alerts)) {
      data.related_alerts = [];
    }
    data.related_alerts.push({ alert_log_id: alert.id });

    let associated_alerts = [...selectedServices];

    const isServiceAlreadyAdded = associated_alerts.some(
        (existingService) => existingService.application_service_id === alert.application_service_id
    );

    if (!isServiceAlreadyAdded) {
      associated_alerts.push({
        name: alert.application_service_name,
        application_service_id: alert.application_service_id,
      })
      setSelectedServices(associated_alerts);
    }

    const completeAlert = {
      id: alert.id,
      name: alert.name,
      resource_name: alert.resource_name,
      metric_name: alert.metric_name,
      opened_at: alert.opened_at,
      closed_at: alert.closed_at,
      integration_type: alert.integration_type,
      application_service_id: alert.application_service_id,
      application_service_name: alert.application_service_name
    };

    const alertsToAdd = [...alertsToSelect, completeAlert];
    setAlertsToSelect(alertsToAdd);

    setDataToSubmit(data);
    setSearchQueryAlerts("");
  };

  const addRcas = (rca) => {
    let data = { ...dataToSubmit };
    if (!Array.isArray(data.related_rcas)) {
      data.related_rcas = [];
    }
    data.related_rcas.push(rca.id);

    const rcasToAdd = [...RcasToSelect, rca];
    setRcasToSelect(rcasToAdd)

    setDataToSubmit(data);
    setSearchQueryRca("");
  };

  const addService = (selectedOption) => {
    let data = { ...dataToSubmit };
    let servicesToSelect = [...selectedServices];

    if (!Array.isArray(data.impacted_applications)) {
      data.impacted_applications = [];
    }
    if (!Array.isArray(servicesToSelect)) {
      servicesToSelect = [];
    }
    const isServiceAlreadyAdded = servicesToSelect.some(
        (existingService) => existingService.application_service_id === selectedOption.value
    );
    if (!isServiceAlreadyAdded) {
      servicesToSelect.push({
        name: selectedOption.label,
        application_service_id: selectedOption.value,
      })
      data.impacted_applications.push(selectedOption.value);
      setDataToSubmit(data);
      setSelectedServices(servicesToSelect);
    }
  };

  const removeService = (value) => {
    let updatedData = { ...dataToSubmit };
    if (updatedData?.impacted_applications?.length > 0){
      updatedData.impacted_applications = updatedData.impacted_applications.filter(
          (id) => id !== value
      );
    }

    const updatedSelectedServices = selectedServices.filter(
        (service) => service.application_service_id !== value
    );

    setDataToSubmit(updatedData);
    setSelectedServices(updatedSelectedServices);
  };

  const validateFunction = async (values) => {
    let errors = {};

    if (!values.title || values.title.trim().length === 0) {
      errors['title'] = 'Please Enter the Title';
    }

    if (!values.status || values.status.trim().length === 0) {
      errors['status'] = 'Please select the status';
    }

    if (!values.incidentDesc || values.incidentDesc.trim().length === 0) {
      errors['incidentDesc'] = 'Please describe the incident';
    }

    if (!values.owner || values.owner.trim().length === 0) {
      errors['owner'] = 'Please enter the owner name';
    }

    return errors;
  };
  const sortedAlertList = alert_list?.sort((a, b) => new Date(b.opened_at) - new Date(a.opened_at)) || [];
  const earliest_alert_name = sortedAlertList[sortedAlertList?.length - 1]?.name;
  const getInitialValues = () => ({
    title: rcaId ? (rca_by_id?.rca?.title || "") : alert_list?.length > 0 ? earliest_alert_name : "",
    owner: rcaId ? allUsers[rca_by_id?.rca?.owner]?.name : (currentUserId ? allUsers[currentUserId]?.name : ""),
    reviewer: rcaId ? allUsers[rca_by_id?.rca?.reviewer]?.name : "",
    incidentDesc: rcaId ? (rca_by_id?.rca?.description || "") : alert_list?.length > 0 ? earliest_alert_name : "",
    status: rcaId ? rca_by_id?.rca?.status : "Open",
    impact_desc: rcaId ? rca_by_id?.impact?.description : ""
  });

  const validation = useFormik({
    enableReinitialize: true,

    validate: validateFunction,

    initialValues: getInitialValues(),

    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter the Title"),
    }),
    onSubmit: (values) => {
        if(enableEdit)
          setActionItemIsOpen(false);
        if(rcaId){
          setEnableEdit(!enableEdit)
          updateAllFieldsPostRca()
        } else {
            submitData();
        }
    }
  });

  const selectUser = (user, type) => {
    if(type === "owner"){
      validation.setFieldValue('owner', user.name)
      dataToSubmit['owner'] = user.id
    }
    if(type === "reviewer"){
      validation.setFieldValue('reviewer', user.name)
      dataToSubmit['reviewer'] = user.id
    }
    setSearchQueryOwner("");
    setSearchQueryReviewer("");
  };

  const updateAllFieldsPostRca = () => {
    const allSections = ['impact','incident_details','header','impacted_applications','related_rcas','timeline','related_alerts','questions','action_items']
    allSections.forEach((section) =>{
      handleUpdate(section);
    });

  };

  const getCompletedActionItems = (rcaId) => {
    const associatedItems = rcas?.action_items?.filter((item) => item?.rca_id === rcaId);
    const completedItems = associatedItems?.filter((item) => item.status === "Completed");
    return {
      completed: completedItems?.length,
      total: associatedItems?.length,
    };
  };

  const handleUpdate = (section) => {
    if(section === "impact"){
      dispatch(updateRcaImpact(
          { rca_id: rcaId,
            rca_impact_id: rca_by_id?.impact?.id,
            description: validation.values.impact_desc,
            images: dataToEdit['impact_images']
          }
      ))
      setLoading({...loading, impact: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, impact: false})
        setIsEditable({...isEditable, impact: false})
      }, 600)
    }
    if(section === "incident_details"){
      dispatch(updateRcaIncidentDetails({
        rca_id: rcaId,
        incident_details: validation.values.incidentDesc
      }))
      setLoading({...loading, incident_details: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, incident_details: false})
        setIsEditable({...isEditable, incident_details: false})
      }, 600)
    }
    if(section === "header"){

      dispatch(updateRcaHeaderDetails({
        rca_id: rcaId,
        owner : validation.values.owner,
        reviewer: validation.values.reviewer,
        status: validation.values.status,
        title : validation.values.title
      }))
      setLoading({...loading, header: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, header: false})
        setIsEditable({...isEditable, header: false})
      }, 600)
    }

    if(section === "impacted_applications"){
      dispatch(updateRcaImpactedApplications({
        rca_id: rcaId,
        impacted_application_ids: selectedServices.map(item => item.application_service_id)
      }))
      setLoading({...loading, impacted_applications: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, impacted_applications: false})
        setIsEditable({...isEditable, impacted_applications: false})
      }, 600)
    }
    if(section === "related_rcas"){
      dispatch(updateRcaRelatedRcas({
        rca_id: rcaId,
        related_rca_ids: RcasToSelect.map(item => item.id)
      }))
      setLoading({...loading, related_rcas: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, related_rcas: false})
        setIsEditable({...isEditable, related_rcas: false})
      }, 600)
    }
    if (section === "timeline" && events.length > 0) {
      events.forEach(x => !x.event_timezone ? x.event_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone : x.event_timezone )
      const formattedEvents = events.map(event => ({
        ...event,
        time: formatTimeForStorage(event.time),
        timestamp: event.timestamp ?
            `${event.timestamp.split(' ')[0]} ${formatTimeForStorage(event.time)}` :
            ''
      }));
      dispatch(updateRcaTimeline({
        rca_id: rcaId,
        timelines: formattedEvents,
      }));
      setTimeout(() => {
         setIsLoading1(false);
         setIsEditable({...isEditable, timeline: false});
      }, 200);
      setIsLoading1(true);
      // dispatch(getRcaById(rcaId));
    }

    if(section === "related_alerts"){
      dispatch(updateRcaRelatedAlerts({
        rca_id: rcaId,
        related_alert_ids: alertsToSelect.map(item => item.id),
      }))
      setLoading({...loading, related_alerts: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, related_alerts: false})
        setIsEditable({...isEditable, related_alerts: false})
      }, 600)
    }
    if(section === "questions"){
      dispatch(updateRcaQuestions({
        rca_id: rcaId,
        questions: questions
      }))
      setTimeout(() => {
        setIsLoading2(false);
        setIsEditable({...isEditable, questions: false});
      }, 200);
      setIsLoading2(true)
      // dispatch(getRcaById(rcaId))
    }
    if(section === "action_items"){
      const updatedActionShortTerm = actionItem.filter( x => x.label === 'ShortTermFix')
      const updatedActionItemsLongTerm = actionItem.filter( x => x.label === 'LongTermFix')

      dispatch(updateRcaActions({
        rca_id: rcaId,
        short_term_actions: updatedActionShortTerm,
        long_term_actions: updatedActionItemsLongTerm
      }))
      setLoading({...loading, action_items: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, action_items: false})
        setIsEditable({...isEditable, action_items: false})
      }, 500)
    }
  }


  const submitData = () => {
    const data = { ...dataToSubmit };

    data['title'] = validation.values.title;
    data['status'] = status;
    data['description'] = validation.values.incidentDesc;
    data['date'] = validation.values.date;

    if(data['owner'] == null || data['owner'] === "" || data['owner'] === undefined){
      data['owner'] = currentUserId
    }
    if(data['status'] === null || data['status'] === "" || data['status'] === undefined){
      data['status'] = "Open"
    }


    const validEvents = events.filter(event =>
        event.date &&
        event.time &&
        event.event.trim()
    );
    // if timezone is missing in any event,  add the timezone
    if (validEvents.length > 0 && validEvents[0].event.trim() !== '') {
      validEvents.forEach(x => !x.event_timezone ? x.event_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone : x.event_timezone )

    }
    data['timeline'] = validEvents.map(event => ({
      ...event,
      time: formatTimeForStorage(event.time),
      timestamp: event.timestamp ?
          `${event.timestamp.split(' ')[0]} ${formatTimeForStorage(event.time)}` :
          ''
    }));

    if(selectedServices.length > 0){
      data['impacted_applications'] = selectedServices.map(item => item.application_service_id)
    }

    if(questions.length > 0 && questions[0].question !== ""){
      data['root_cause_questions'] = questions
    }

    if (validation.values.impact_desc.length > 0) {
      data['impact'] = { ...data.impact, description: validation.values.impact_desc };
    }

    const validActionItems = actionItem.filter(item =>
        item.title && item.title.length > 0 &&
        item.assigned_to && item.assigned_to !== '' &&
        // Additional validation to ensure assigned_to is a valid UUID
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(item.assigned_to)
    );

    const updatedActionItemsLongTerm = validActionItems.filter( x => x.label === 'LongTermFix')
    const updatedActionShortTerm = validActionItems.filter( x => x.label === 'ShortTermFix')

    if(updatedActionItemsLongTerm.length > 0){
      data['long_term_actions'] = updatedActionItemsLongTerm;
    }

    if(updatedActionShortTerm.length > 0){
      data['short_term_actions'] = updatedActionShortTerm;
    }

    dispatch(postFullRca(data));
    window.location.href="/RCA?tab=RCA"

  };

  const handleChangeDesc = (typeOfDescription,value) => {
    validation.setFieldValue(typeOfDescription, value)
  }

  //function to add images
  const handleFileChange = (index, event, imageType) => {
    const files = event.target.files;
    const updatedEvents = [...events];
    let updatedImpactImages = [...(allImages.impact || [])];
    const updatedQuestions = [...questions]
    let currentImages = [];

    if (imageType === 'timeline') {
      currentImages = updatedEvents[index]?.images || [];
    } else if (imageType === 'impact') {
      currentImages = updatedImpactImages || [];
    } else if (imageType === 'questions') {
      currentImages = updatedQuestions[index]?.images || [];
    }
    const startPosition = currentImages.length;

    const selectedImages = Array.from(files).map((file, idx) => ({
      name: file.name,
      image: file,
      previewUrl: URL.createObjectURL(file),
      position: startPosition + idx
    }));

    if(imageType === "timeline"){
      if (updatedEvents[index]) {
        updatedEvents[index].images = [
          ...(updatedEvents[index].images || []),
          ...selectedImages,
        ];
      }

      setEvents(updatedEvents);
    }

    if (imageType === 'impact') {
      updatedImpactImages = [...updatedImpactImages, ...selectedImages];

      setAllImages({
        ...allImages,
        impact: updatedImpactImages,
      });

      if (!dataToSubmit.impact) {
        dataToSubmit.impact = {};
      }
      dataToSubmit.impact['images'] = updatedImpactImages;
    }

    if(imageType === "questions") {
      if(updatedQuestions[index]){
        updatedQuestions[index].images = [
          ...updatedQuestions[index].images || [],
          ...selectedImages
        ]
      }

      setQuestions(updatedQuestions)
    }
  };

  const addQuestion = () => {
    setQuestions([...questions, {question: '', response: '', images: []}]);
  }
  const handleInputChange = (index, field, value, type) => {
    const updatedEvents = [...events];
    const updatedQuestions = [...questions];

    if (type === "timeline") {
      if (field === 'date') {
        try {
          if (!value) {
            updatedEvents[index].date = '';
            setEvents(updatedEvents);
            return;
          }
          updatedEvents[index].date = value;

          const existingTime = updatedEvents[index].time || '00:00';
          const [year, month, day] = value.split('-');

          updatedEvents[index].timestamp = `${day}-${month}-${year} ${existingTime}`;
          updatedEvents[index].time = existingTime;

        } catch (error) {
          console.error('Error handling date change:', error);
          return;
        }
      } else if (field === 'time') {
        // Convert time input value to HH:MM format
        updatedEvents[index].time = value;

        if (updatedEvents[index].date) {
          const [year, month, day] = updatedEvents[index].date.split('-');
          updatedEvents[index].timestamp = `${day}-${month}-${year} ${value}`;
        }
      } else {
        updatedEvents[index][field] = value;
      }

      if (field === "event" && index === updatedEvents.length - 1 && value) {
        const lastEvent = updatedEvents[index];

        let newTimestamp = '';
        if (lastEvent.timestamp) {
          try {
            // Parse existing timestamp (dd-mm-yyyy hh:mm)
            const [datePart, timePart] = lastEvent.timestamp.split(' ');
            const [day, month, year] = datePart.split('-');
            const [hours, minutes] = timePart.split(':');

            const lastDate = new Date(year, month - 1, day, hours, minutes);
            lastDate.setMinutes(lastDate.getMinutes() + 10);

            // Format new timestamp
            const newDay = lastDate.getDate().toString().padStart(2, '0');
            const newMonth = (lastDate.getMonth() + 1).toString().padStart(2, '0');
            const newYear = lastDate.getFullYear();
            const newHours = lastDate.getHours().toString().padStart(2, '0');
            const newMinutes = lastDate.getMinutes().toString().padStart(2, '0');

            newTimestamp = `${newDay}-${newMonth}-${newYear} ${newHours}:${newMinutes}`;
          } catch (error) {
            console.error('Error calculating new timestamp:', error);
            return;
          }
        }

        updatedEvents.push({
          event: '',
          date: lastEvent.date,
          time: newTimestamp ? newTimestamp.split(' ')[1] : lastEvent.time,
          timestamp: newTimestamp || lastEvent.timestamp,
          event_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          images: []
        });
      }

      setEvents(updatedEvents);
    }

    if (type === "questions") {
      updatedQuestions[index][field] = value;
      const lastItem = updatedQuestions[updatedQuestions.length - 1];
      if (
          (lastItem.question || lastItem.response) &&
          (field === "question" || field === "response")
      ) {
        updatedQuestions.push({
          question: '',
          response: '',
          images: []
        });
      }
      setQuestions(updatedQuestions);
    }
  };


  const displayTimeFormat = (timestamp) => {
    //function for displaying time from timestamp when not in enableEdit mode
    if (!timestamp) return '';

    try {
      const [, timeStr] = timestamp.split(' ');
      if (!timeStr) return '';

      const [hours, minutes] = timeStr.split(':');
      const hour = parseInt(hours, 10);
      const minute = parseInt(minutes, 10);

      if (isNaN(hour) || isNaN(minute)) return '';

      // Convert to 12-hour format for display
      const period = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour % 12 || 12;
      return `${displayHour}:${minutes.padStart(2, '0')} ${period}`;
    } catch (error) {
      console.error('Error formatting time for display:', error);
      return '';
    }
  };

  function formatTimeForInput(timestamp) {
    // function for converting received timestamp to dd:mm:yy hh:mm format
    const date = new Date(timestamp);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  const removeItem = (index, type) => {
    if(type === "timeline"){
      const updatedEvents = events.filter((_, i) => i !== index);
      setEvents(updatedEvents);
    }
    if(type === "questions"){
      const updatedQuestions = [...questions];
      updatedQuestions.splice(index, 1);
      setQuestions(updatedQuestions);
    }
    if(type === "related_rcas"){
      const updatedRelatedRcas = RcasToSelect.filter((_, i) => i !== index);
      setRcasToSelect(updatedRelatedRcas);
    }
    if(type === "related_alerts"){
      const updatedRelatedRcas = alertsToSelect.filter((_, i) => i !== index);
      setAlertsToSelect(updatedRelatedRcas);
    }

  };

  const customStyles = {
    // zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      // color: "white",
      // zIndex: 100,
      position:"relative",
      borderColor: null // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      // zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      // zIndex: 100,
    }),
  };

  const prefillDate = (oldestDate) => {
    if (oldestDate) {
      const firstEvent = events[0];
      if (!firstEvent.event || firstEvent.event && !firstEvent.time && !firstEvent.date) {
        const formattedDate = new Date(oldestDate).toISOString().split('T')[0];
        const formattedTime = new Date(oldestDate).toTimeString().slice(0, 5);
        firstEvent.date = formattedDate;
        firstEvent.time = formattedTime;
      }
    }
  };
  const getOldestAlertDate = (alerts) => {
    if (!alerts || alerts.length === 0) return null;

    const sortedAlerts = [...alerts].sort((a, b) => {
      const dateA = isEditable.related_alerts ? moment(a?.opened_at) : moment(a?.alert_log?.opened_at);
      const dateB = isEditable.related_alerts ? moment(b?.opened_at) : moment(b?.alert_log?.opened_at);
      return dateA - dateB;
    });
    return isEditable.related_alerts ? sortedAlerts[0]?.opened_at : sortedAlerts[0]?.alert_log?.opened_at;
  };

  useEffect(() => {
    const oldestDate = getOldestAlertDate(alertsToSelect);
    prefillDate(oldestDate);
  }, [alertsToSelect, rca_by_id]);

  const handleDeleteRca = () => {
    setDeleteConfirmationModalIsOpen(true)
  }

  const handleDelete = () => {
    dispatch(deleteRcaById(rcaId));
    setDeleteConfirmationModalIsOpen(false)
  }

  const toggleModal = () => {
    setDeleteConfirmationModalIsOpen(!deleteConfirmationModalIsOpen)
  }

  const [popoverOpen2, setPopoverOpen2] = useState({});
  const [alertPopover,setAlertPopover] = useState({});

  const togglePopoverService = (key, isOpen) => {
    setPopoverOpen2(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };
  const handleMouseEnterAlert = (id) => {
    setAlertPopover(prevState => ({
      ...prevState,
      [id]: true,
    }));
  };

  const handleMouseLeaveAlert = (id) => {
    setAlertPopover(prevState => ({
      ...prevState,
      [id]: false,
    }));
  };

  const handleMouseEnterService = (key) => {
    togglePopoverService(key, true);
  };

  const handleMouseLeaveService = (key) => {
    togglePopoverService(key, false);
  };

  const resetFormStates = () => {
    setActionItems({
      short_term_actions: [],
      long_term_actions: [],
      all: [],
    });
    setEvents([{date: '', time: '', event: '', timestamp: '', images: [],event_timezone: ''}]);
    setQuestions([{question: '', response: '', images: []}]);
    setAlertsToSelect([]);
    setRcasToSelect([]);
    setSelectedServices([]);
    setDataToSubmit({});
    setDataToEdit({});
    setAllImages({impact: []});

    // Reset Formik completely with empty values
    validation.resetForm({
      values: {
        title: "",
        owner: currentUserId ? allUsers[currentUserId]?.name : "",
        reviewer: "",
        incidentDesc: "",
        status: "Open",
        impact_desc: ""
      }
    });
  };

  const [searchQueryUser, setSearchQueryUser] = useState("");
  const [assignedUsers, setAssignedUsers] = useState({});
  const [activeDropdownId, setActiveDropdownId] = useState(null);

  const labelOptions = [
    { value: "ShortTermFix", label: "Short Term" },
    { value: "LongTermFix", label: "Long Term" },
  ];

  const statusOptions1 = [
    { value: "Pending", label: "Pending" },
    { value: "InProgress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
  ];

  const [selectedLabels, setSelectedLabels] = useState(
      actionItem.map(() => ({ value: "ShortTermFix", label: "Short Term" }))
  );

  const [selectedStatuses, setSelectedStatuses] = useState(
      actionItem.map(() => ({ value: "Pending", label: " Pending" }))
  );


  const filteredUsers1 = Object.entries(allUsers).filter(([id, user]) =>
      user.name.toLowerCase().includes(searchQueryUser.toLowerCase())
  );

  const removeActionItemCard = (index) => {
      const updatedCardState = [...actionItem]
      updatedCardState.splice(index, 1)
      setActionItem(updatedCardState)
  };

  const updateActionItemCard = (index, field, value) => {
    const oldState = [...actionItem]
    oldState[index][field] = value;
    const lastItem = oldState[oldState.length - 1];
    if (field === 'title' && index === lastItem.id && value.length > 0) {
      const newItem = {
        id: oldState.length,
        title: '',
        target_date: getDefaultTargetDate(),
        assigned_to: '',
        description: '',
        position : oldState.length ,
        label: 'ShortTermFix',
        status: 'Pending'
      };
      oldState.push(newItem);
      setSelectedLabels(prev => ({
        ...prev,
        [newItem.id]: labelOptions.find(opt => opt.value === 'ShortTermFix')
      }));

      setSelectedStatuses(prev => ({
        ...prev,
        [newItem.id]: statusOptions1.find(opt => opt.value === 'Pending')
      }));
    }
    setActionItem(oldState);
  }


  function addNewCard() {
    const oldState = [...actionItem]
     const newItem =   {
      id: oldState.length,
      title: '',
      target_date: getDefaultTargetDate(),
      assigned_to: '',
      description: '',
      position : oldState.length ,
      label: 'ShortTermFix',
      status: 'Pending'
    }
    setSelectedLabels(prev => ({
      ...prev,
      [newItem.id]: labelOptions.find(opt => opt.value === 'ShortTermFix')
    }));

    setSelectedStatuses(prev => ({
      ...prev,
      [newItem.id]: statusOptions1.find(opt => opt.value === 'Pending')
    }));
    actionItem.push(newItem);
  }

  function addTimelineEvent() {
    const lastEvent = events[events.length - 1];

    let newTimestamp = '';
    if (lastEvent.timestamp) {
      try {
        const [datePart, timePart] = lastEvent.timestamp.split(' ');
        const [day, month, year] = datePart.split('-');
        const [hours, minutes] = timePart.split(':');

        const lastDate = new Date(year, month - 1, day, hours, minutes);
        lastDate.setMinutes(lastDate.getMinutes() + 10);

        const newDay = lastDate.getDate().toString().padStart(2, '0');
        const newMonth = (lastDate.getMonth() + 1).toString().padStart(2, '0');
        const newYear = lastDate.getFullYear();
        const newHours = lastDate.getHours().toString().padStart(2, '0');
        const newMinutes = lastDate.getMinutes().toString().padStart(2, '0');

        newTimestamp = `${newDay}-${newMonth}-${newYear} ${newHours}:${newMinutes}`;
      } catch (error) {
        console.error('Error calculating new timestamp:', error);
        return;
      }
    }

    events.push({
      event: '',
      date: lastEvent.date,
      time: newTimestamp ? newTimestamp.split(' ')[1] : lastEvent.time,
      timestamp: newTimestamp || lastEvent.timestamp,
      event_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      images: []
    });
  }

  function updateStatus(status) {
    if(rcaId){
      dispatch(updateRcaHeaderDetails({
        rca_id: rcaId,
        status: status,
      }))
      setLoading({...loading, header: true})
      setTimeout(() => {
        // dispatch(getRcaById(rcaId))
        setLoading({...loading, header: false})
        setIsEditable({...isEditable, header: false})
      }, 600)
    }
  }

  return(
      <React.Fragment>
        <div className="d-flex w-100 scroll-padding">
          <div className="sidebar"
               style={{
                 width: '240px',
                 backgroundColor: '#4b37494d',
                 height: '100%',
                 backdropFilter: 'blur(20px)',
                 borderRight: '1px solid #ffffff26',
               }}>
            <ul style={{listStyleType: "none", fontSize:"14px", marginTop:"100px"}}>
              <li><a href="#rca-details">RCA Details</a></li>
              <li><a href="#linked-references">Linked References</a></li>
              <li><a href="#incident-details">Incident Details</a></li>
              <li><a href="#impact">Impact</a></li>
              <li><a href="#root-cause-analysis">Root Cause Analysis</a></li>
              <li><a href="#action-items">Action Items</a></li>
            </ul>
          </div>
          <div className="w-100" style={{marginLeft:`${viewSidebar ? "240px" : "0"}`}}>
            <div
              className="d-flex justify-content-start align-items-center p-3"
              style={{width:`${viewSidebar ? '85%' : '100%'}`,
                backgroundColor:"#2d213d",
                position:"fixed",
                marginTop:"-1rem",
                right:"0",
                zIndex:"99",
                left:`${viewSidebar ? "240px" : "0"}` }}
            >
              <div className="w-100 mx-3 d-flex justify-content-between align-items-center" >
                <div className="d-flex gap-3 align-items-center">
                  <Link to="/RCA?tab=RCA">
                    <span role="button">
                      <i className="bx bx-left-arrow-alt font-size-22 text-white" />
                    </span>
                  </Link>
                  {/*<span role="button" onClick={toggleSidebar}><i className="bx bx-menu font-size-22 text-white"/></span>*/}
                  <span className="font-size-15 text-white">
                    {rca_by_id?.rca?.title}
                  </span>
                </div>
                <div style={{width:"80%"}} className="d-flex align-items-center justify-content-end gap-3">
                  {validation.errors.status && validation.touched.status && (
                      <div className="text-danger">{validation.errors.status}</div>
                  )}
                  <div style={{width:"20%"}}>
                    {editMode || rcaId?
                      <Select
                        value={statusOptions.find(option => option.value === validation.values.status) ||
                          statusOptions.find(option => option.value === "Open")}
                        options={statusOptions}
                        onChange={(selectedOption) => {
                          validation.setFieldValue("status", selectedOption ? selectedOption.value : "");
                          setStatus(selectedOption.value)
                          updateStatus(selectedOption.value)
                        }}
                        placeholder="Status"
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      /> : <div className="input h-100">{rca_by_id?.rca?.status}</div>}
                  </div>
                  <form onSubmit={validation.handleSubmit}>
                    {editMode || rcaId && enableEdit ?
                      <button type="submit" className="btn btn-primary">
                        Save Changes{/*<i className="bx bx-save"/>*/}
                      </button>
                      :
                      <span id="editExistingRca" role="button" onClick={() => setEnableEdit(!enableEdit)}>
                        <button type="submit" className="btn btn-primary">
                          Edit RCA{/*<i className="bx bx-save"/>*/}
                        </button>
                      </span>
                    }

                  </form>
                  <UncontrolledTooltip className="rca-tooltip-component" placement="top" target="editExistingRca">
                    Edit Rca
                  </UncontrolledTooltip>
                  {rcaId && <UncontrolledTooltip className="rca-tooltip-component" placement="top" target="deleteExistingRca">
                    Delete Rca
                  </UncontrolledTooltip>}
                  {rcaId && <span id="deleteExistingRca" role="button" onClick={handleDeleteRca}
                         className="text-danger font-size-22">
                    <i className="mdi mdi-delete-outline"/>
                  </span>}
                </div>
              </div>
            </div>
            <div className="d-flex gap-0 ms-5">
              <div style={{marginBottom:"10%", marginTop:"8%", width:"100%"}}>
                <div className="d-flex me-5">
                  <div className="w-100 d-flex justify-content-center">
                    <div style={{width:"100%"}}>
                      <div id="rca-details" style={{scrollMarginTop: "200px"}} className="d-inline-flex justify-content-start w-100">
                        <div className="d-flex flex-column mb-3 w-75">
                          <div className="w-100 d-inline-flex">
                            <h4 className='text-white'>Title</h4>
                          </div>
                          {enableEdit || !rcaId ? (
                            <input
                              id="title"
                              name="title"
                              className="input w-75"
                              style={{height: "39%"}}
                              placeholder={"Enter Title"}
                              onBlur={validation.handleBlur}
                              value={validation.values.title}
                              onChange={validation.handleChange}
                            />
                          ) : (
                            <div>
                              <span className='text-white'>
                                {rca_by_id?.rca?.title ? rca_by_id.rca.title : "No title available"}
                              </span>
                            </div>
                          )}
                          {validation.errors.title && validation.touched.title && (
                            <div className="text-danger">{validation.errors.title}</div>
                          )}
                        </div>
                        <div className="d-flex flex-column w-30">
                          <div className="d-flex flex-column mb-3">
                            <div className="w-100 d-inline-flex">
                              <h6 className='text-white'>Owner</h6>
                            </div>
                            {enableEdit || !rcaId ?
                              <div className="d-flex align-items-end justify-content-end">
                                <Select
                                  required={true}
                                  name="owner"
                                  id="owner"
                                  className="custom_select"
                                  placeholder={"Search: name"}
                                  options={Object.entries(allUsers).map(([id, user]) => ({
                                    value: id,
                                    label: user.name
                                  }))}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.owner
                                    ? {value: validation.values.owner, label: validation.values.owner}
                                   : null
                                  }
                                  onChange={(selectedOption) => {
                                    if (selectedOption) {
                                      const selectedUser = allUsers[selectedOption.value];
                                      setSearchQueryOwner(selectedOption.label);
                                      validation.setFieldValue('owner', selectedUser?.name);
                                      selectUser(selectedUser, "owner");
                                    } else {
                                      setSearchQueryOwner('');
                                      validation.setFieldValue('owner', '');
                                      dataToSubmit["owner"] = null;
                                    }
                                  }}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      neutral0: '#222736',
                                      neutral5: '#485EC4',
                                      neutral10: '#485EC4',
                                      neutral60: '#ffffff',
                                      neutral70: '#ffffff',
                                      neutral80: '#ffffff',
                                      neutral90: '#ffffff',
                                      primary: '#485EC4',
                                    },
                                  })}
                                  styles={customStyles}
                                />
                              </div>
                              :
                              <div className='text-white'>{allUsers[rca_by_id?.rca?.owner]?.name}</div>
                            }
                            {validation.errors.owner && validation.touched.owner && (
                              <div className="text-danger">{validation.errors.owner}</div>
                            )}
                          </div>
                          <div className="d-flex flex-column mb-3">
                            <div className="w-100 d-inline-flex">
                              <h6 className='text-white'>Reviewer</h6>
                            </div>
                            {enableEdit || !rcaId ?
                              <div className="d-flex align-items-center">
                                <Select
                                  required={true}
                                  name="reviewer"
                                  id="reviewer"
                                  className="custom_select"
                                  placeholder={rcaId ? `${allUsers[rca_by_id?.rca?.reviewer]?.name}` : "Search: name"}
                                  onBlur={validation.handleBlur}
                                  options={Object.entries(allUsers).map(([id, user]) => ({
                                    value: id,
                                    label: user.name
                                  }))}
                                  value={validation.values.reviewer
                                    ? {value: validation.values.reviewer, label: validation.values.reviewer}
                                    : null
                                  }
                                  onChange={(selectedOption) => {
                                    if (selectedOption) {
                                      const selectedUser = allUsers[selectedOption.value];
                                      setSearchQueryReviewer(selectedOption.label);
                                      validation.setFieldValue('reviewer', selectedUser?.name);
                                      selectUser(selectedUser, "reviewer");
                                    } else {
                                      setSearchQueryReviewer('');
                                      validation.setFieldValue('reviewer', '');
                                      dataToSubmit["reviewer"] = null;
                                    }
                                  }}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      neutral0: '#222736',
                                      neutral5: '#485EC4',
                                      neutral10: '#485EC4',
                                      neutral60: '#ffffff',
                                      neutral70: '#ffffff',
                                      neutral80: '#ffffff',
                                      neutral90: '#ffffff',
                                      primary: '#485EC4',
                                    },
                                  })}
                                  styles={customStyles}
                                />
                              </div>
                              :
                              <div className='text-white'>{allUsers[rca_by_id?.rca?.reviewer]?.name}</div>
                            }
                            {validation.errors.reviewer && validation.touched.reviewer && (
                              <div className="text-danger">{validation.errors.reviewer}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={{scrollMarginTop: "160px"}} id="linked-references">
                        <div className="w-100 d-inline-flex">
                            <h4>Associated Alerts</h4>
                        </div>
                        <div>
                          <div className="w-25 mb-3 mt-2">
                            {isEditable.related_alerts || enableEdit ?
                              <input
                                className="input w-100"
                                placeholder="Search: name"
                                value={searchQueryAlerts}
                                onChange={(e) => setSearchQueryAlerts(e.target.value)}
                              /> : null
                            }
                            {searchQueryAlerts && (
                              <div className="rca-search">
                                <ul>
                                  {filteredAlerts.map(([id, alert]) => (
                                    <li onClick={() => {
                                      addAlerts(alert)
                                    }} key={id}>
                                      <div className="d-flex justify-content-between align-items-center p-2">
                                        {alert.name}
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {searchQueryAlerts && filteredAlerts.length === 0 && (
                              <div className="rca-search d-flex justify-content-center">No alerts found</div>
                            )}
                          </div>
                          <div className="mt-3 mb-4" style={{width: "90%"}}>
                            <Card bg="transparent">
                              <div className="d-flex flex-column justify-content-center align-items-center">
                                <CardHeader>
                                  <Row className="align-items-center padding-t-10 bg-transparent">
                                    <Col md="2">
                                      <div className="text-center">
                                        {"Alert Name"}
                                      </div>
                                    </Col>
                                    <Col md="2">
                                      <div className="text-center">
                                        {"Application"}
                                      </div>
                                    </Col>
                                    <Col md="2">
                                      <div className="text-center">
                                        {"Resource"}
                                      </div>
                                    </Col>
                                    <Col md="2">
                                      <div className="text-center">
                                        {"Metric"}
                                      </div>
                                    </Col>
                                    <Col md="3">
                                      <div className="text-center">
                                        {"Timeline"}
                                      </div>
                                    </Col>
                                    <Col md="1">
                                      <div className="text-center">
                                        {"Action"}
                                      </div>
                                    </Col>
                                  </Row>
                                </CardHeader>
                                {alertsToSelect.map((item, index) => (
                                  <CardItem key={index}>
                                    <div>
                                      <Row>
                                        <Col md="2">
                                          <div className="d-flex align-items-center justify-content-left">
                                            <img
                                              src={getIntegrationLogo(item.integration_type ? item.integration_type : alerts?.find(alert => alert?.id === item?.id)?.integration_type)}
                                              alt={item.integration_type}
                                              className="avatar-xs rounded-circle"
                                              style={{ height: "20px", width: "20px", marginRight: "5px" }}
                                            />
                                            <Link
                                              className="resource-name-truncate text-center"
                                              id={`alertlog-alert-name-${item.id}`}
                                              to={`/alert-log/${item.id}`}
                                              onMouseEnter={() => handleMouseEnterAlert(item.id)}
                                              onMouseLeave={() => handleMouseLeaveAlert(item.id)}>
                                              {item?.name?.length > 25 ? item.name.substring(0, 25) + "..." : item?.name }
                                            </Link>
                                            <Popover
                                              isOpen={alertPopover[item.id] || false}
                                              target={`alertlog-alert-name-${item.id}`}
                                              placement="top">
                                              <PopoverBody>{item.name}</PopoverBody>
                                            </Popover>
                                          </div>
                                        </Col>
                                        <Col md="2" className="align-items-center text-left">
                                          <h6 className="resource-name-truncate mb-0">
                                            <Link
                                                id={`alertlog-service-name-${item.id}`}
                                                to={`/temperstack-notifications/${item.application_service_id}`}
                                                onMouseEnter={() => handleMouseEnterService(item.id)}
                                                onMouseLeave={() => handleMouseLeaveService(item.id)}
                                                className="link-primary text-center"
                                            >
                                              {item.application_service_name}
                                            </Link>
                                            <Popover
                                                isOpen={popoverOpen2[item.id] || false}
                                                target={`alertlog-service-name-${item.id}`}
                                                placement="top"
                                            >
                                              <PopoverBody>{item.application_service_name}</PopoverBody>
                                            </Popover>
                                          </h6>
                                        </Col>
                                        <Col className="resource-name-truncate align-items-center text-center" md="2">
                                          {item.resource_name}
                                        </Col>
                                        <Col className="resource-name-truncate align-items-center text-center" md="2">
                                          {item.metric_name}
                                        </Col>
                                        <Col className="resource-name-truncate align-items-center text-center" md="3">
                                          {`${moment(item.opened_at).format("DD MMM YY HH:mm")} - ${
                                              item.closed_at ? moment(item.closed_at).format("DD MMM YY HH:mm") : alerts?.find(alert => alert?.id === item?.id)?.closed_at ?
                                                  moment(alerts?.find(alert => alert?.id === item?.id).closed_at)?.format("DD MMM YY HH:mm") : "Now"
                                          }`}
                                        </Col>
                                        {isEditable.related_alerts || enableEdit ? (
                                            <Col className="text-center" md="1">
                                              <div>
                                                <span role="button" onClick={() => removeItem(index, "related_alerts")}>
                                                  <i className="mdi mdi-delete font-size-20 text-danger" />
                                                </span>
                                              </div>
                                            </Col>
                                        ) : null}
                                      </Row>
                                    </div>
                                  </CardItem>
                                ))}
                                {alertsToSelect.length === 0 && <div>No alerts selected</div>}
                              </div>
                              {loading.related_alerts && <div className="spinner-border text-primary"></div>}
                            </Card>
                          </div>
                        </div>
                        {/*: null*!/*/}
                        {/*}*/}

                        <div className="w-100 d-inline-flex">
                          <div className={ rcaId ? "d-inline-flex" : "d-inline-flex pt-2"}>
                            <h4>Impacted Services</h4>
                          </div>
                        </div>
                        {isEditable.impacted_applications || enableEdit ?
                          <div className={!rcaId ?"w-25 mb-3 mt-2" : "w-25 mb-3 mt-2"}>
                            <Select
                              isClearable
                              options={[
                                ...serviceOptions
                              ]}
                              value={selectedService}
                              placeholder="Add Service"
                              onChange={(selectedOption) => {
                                if (selectedOption) {
                                  if(selectedOption.value === "/add-service"){
                                    window.location.href = "/add-service";
                                  }
                                  addService(selectedOption);
                                }
                              }}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  neutral0: '#222736',
                                  neutral5: '#485EC4',
                                  neutral10: '#485EC4',
                                  neutral60: '#ffffff',
                                  neutral70: '#ffffff',
                                  neutral80: '#ffffff',
                                  neutral90: '#ffffff',
                                  primary: '#485EC4',
                                },
                              })}
                              styles={customStyles}
                            />
                          </div> : null
                        }

                        <div className="d-flex w-100 gap-3 mt-2">
                          {(isEditable.impacted_applications || enableEdit ? selectedServices : rca_by_id?.impacted_application_services)?.map((item) => (
                            <div className="btn btn-primary text-white bg-primary p-1 px-3 d-flex align-items-center justify-content-center gap-2"
                                 key={item.id}>
                              <span>
                                {isEditable.impacted_applications  || enableEdit? item?.name : item?.application_service?.name}
                              </span>
                              {
                                isEditable.impacted_applications || enableEdit ?
                                  <span role="button" onClick={() => removeService(item.application_service_id)}>
                                    <i className="mdi mdi-delete text-white font-size-16 mt-1"></i>
                                  </span> : null
                              }
                            </div>
                          ))}
                          {
                            loading.impacted_applications ? <div className="spinner-border text-primary"></div> : null
                          }
                        </div>
                        <div className={rcaId? "w-100 d-inline-flex pt-4" : "w-100 d-inline-flex pt-2"}>
                          <div className="d-inline-flex">
                            <h4>Related RCAs</h4>
                          </div>
                        </div>

                        {isEditable.related_rcas || enableEdit ?
                            <input className="input w-25 mt-2"  onChange={(e) => setSearchQueryRca(e.target.value)}  placeholder="Search: name"></input> : null
                        }
                        {searchQueryRca && (
                            <div className="rca-search w-25">
                              <ul>
                                {filteredRcas.map(([id, rca]) => (
                                    <li onClick={() => addRcas(rca)} key={id}>
                                      <div className="d-flex justify-content-between align-items-center p-2 w-100">
                                        {rca.title}
                                      </div>
                                    </li>
                                ))}
                              </ul>
                            </div>
                        )}

                        {searchQueryRca && filteredRcas.length === 0 && (
                            <div className="w-25 rca-search d-flex justify-content-center">No Rcas found</div>
                        )}

                        <div className="mt-3 d-flex align-items-center" style={{width:"90%"}}>
                          <Card bg="transparent">
                            <CardHeader>
                              <Row>
                                <Col className="text-center resource-name-truncate" md="3">Title</Col>
                                <Col className="text-center" md="2">Date Created</Col>
                                <Col className="text-center" md="1">Status</Col>
                                <Col className="text-center" md="2">Action Items</Col>
                                <Col className="text-center" md="2">Owner</Col>
                                <Col className="text-center" md="1">Reviewer</Col>

                                { enableEdit ? <Col className="text-center" md="1">Actions</Col> : null }
                              </Row>
                            </CardHeader>
                            <div className="d-flex flex-column justify-content-center align-items-center">
                              { RcasToSelect?.map((item, index) => {
                                const {completed, total} = getCompletedActionItems(item.id);

                                return(<CardItem key={index}>
                                  <div>
                                    <Row>
                                      <Col className="resource-name-truncate text-center" md="3">
                                        {enableEdit ? item.title :
                                            <Link className="resource-name-truncate text-center"
                                                  to={`/rca-form/${item?.id}`}>
                                              {item?.title.length > 30 ? item?.title.substring(0,30) + "..." : item?.title}
                                            </Link>
                                        }
                                      </Col>
                                      <Col className="resource-name-truncate text-center" md="2">
                                        {getDate(item.updated_at)}
                                      </Col>
                                      <Col className="resource-name-truncate text-center" md="1">
                                        {item.status}
                                      </Col>
                                      <Col className="resource-name-truncate text-center" md="2">
                                        {`${completed}/${total} completed`}
                                      </Col>
                                      <Col className="resource-name-truncate text-center" md="2">
                                        {allUsers[item.owner]?.name ? allUsers[item.owner]?.name : allUsers[rcas?.rca?.find(x => x?.rca?.id === item?.id)?.rca?.owner]?.name}
                                      </Col>
                                      <Col className="resource-name-truncate text-center" md="1">
                                        {item.reviewer ? allUsers[item.reviewer]?.name : "-"}
                                      </Col>

                                      {enableEdit ?
                                          <Col className="text-center" md="1">
                                            <div className="d-flex justify-content-center align-items-center">
                                                <span className="w-100" role="button" onClick={() => removeItem(index, "related_rcas")}>
                                                  <i className="mdi mdi-delete font-size-20 text-danger"/>
                                                </span>
                                            </div>
                                          </Col> : null
                                      }
                                    </Row>
                                  </div>
                                </CardItem>)
                              })}
                              {(RcasToSelect.length === 0 && (!rca_by_id?.related_past_rcas || rca_by_id?.related_past_rcas.length === 0)) ?
                                  <div>No related past RCAs</div> : null
                              }
                              {loading.related_rcas ?
                                  <div className="spinner-border text-primary"></div>  : null
                              }
                            </div>
                          </Card>
                        </div>

                        <div style={{scrollMarginTop:"160px"}} id="incident-details" className="my-4">
                          <div className="d-inline-flex">
                            <h4>Incident Details</h4>
                          </div>
                          <div className="custom-toolbar-example mt-1" style={{width: "90%"}}>
                            <Editor
                                handleChangeFunc={handleChangeDesc}
                                typeOfDesc={'incidentDesc'}
                                dataToPrefill={ rcaId ? rca_by_id?.rca?.description : alert_list?.length > 0 ? earliest_alert_name : ""}
                                enableEdit={enableEdit || enableEditOnCreate}
                            />
                          </div>
                          {validation.errors.incidentDesc && validation.touched.incidentDesc && (
                              <div className="text-danger">{validation.errors.incidentDesc}</div>
                          )}
                          <div className="d-flex mt-4 ">
                            <div className="w-100 d-inline-flex">
                              <h4>Timeline</h4>
                              {!enableEdit && rcaId?
                                  null : <i className="bx bx-plus-circle text-primary font-size-20 ms-2" style={{marginTop: "2px"}}
                                   onClick={() => {
                                     addTimelineEvent();
                                   }}/>
                              }
                            </div>
                          </div>
                          {isLoading1 ? (
                              <div className="spinner-border text-primary"></div>
                          ) : (
                          events?.map((event, index) => (
                            <div key={index}>
                              <div className="d-inline-flex w-100">
                                <div className="d-flex align-items-center gap-4" style={{width: "90%"}}>
                                  <div className="d-inline-flex my-2 gap-2 w-25">
                                    {isEditable.timeline || enableEdit ?
                                        <input
                                            className="input w-100"
                                            type="date"
                                            value={formatDateForInput(event.timestamp) || ''}
                                            onChange={(e) => {
                                              handleInputChange(index, 'date', e.target.value, "timeline");
                                            }}
                                        />
                                        :
                                        <div className="input w-100">{formatDateForDisplay(event.timestamp,true)}</div>
                                    }
                                    {isEditable.timeline || enableEdit ?
                                        <input
                                            className="input w-100"
                                            type="time"
                                            value={extractTime(event.timestamp) || ''}
                                            onChange={(e) => handleInputChange(index, 'time', e.target.value, "timeline")}
                                        /> :
                                        <div className="input w-100">{displayTimeFormat(event.timestamp)}</div>
                                    }
                                  </div>
                                  <div className="h-full d-flex align-items-center ms-1 w-100 ">
                                  {isEditable.timeline || enableEdit ?
                                        <input
                                            className="input"
                                            style={{width: '100%'}}
                                            placeholder={`Event ${index + 1}`}
                                            value={event.event}
                                            onChange={(e) =>
                                              handleInputChange(index, 'event', e.target.value, "timeline")
                                            }
                                        /> :
                                        <div className="input w-100">{event.event}</div>
                                    }
                                  </div>

                                  {loading.timeline ?
                                      <div className="spinner-border text-primary"></div> : null
                                  }
                                </div>
                                <span className="ms-3 pt-2 ">
                                {isEditable.timeline || enableEdit ?
                                    <i
                                        className="mdi mdi-delete font-size-18 text-danger"
                                        style={{cursor: 'pointer'}}
                                        onClick={() => removeItem(index, "timeline")}
                                    /> :
                                    null
                                }
                              </span>
                              </div>
                              </div>
                              )))}
                          {(events.length === 0 && (!rca_by_id?.rca_timelines || rca_by_id?.rca_timelines.length === 0)) ?
                              <div className="d-flex align-items-center justify-content-center font-size-13 text-white" style={{width:"90%"}}>No Timeline Added</div> : null
                          }
                        </div>
                        <div className="my-4">
                          <h4 className="mb-3">Impact</h4>
                          <div className="custom-toolbar-example" style={{width: "90%"}}>
                            <Editor
                              handleChangeFunc={handleChangeDesc}
                              typeOfDesc={'impact_desc'}
                              dataToPrefill={rca_by_id?.impact?.description ?? ' '}
                              enableEdit={enableEdit || enableEditOnCreate}
                            />
                          </div>
                          {loading.impact ?
                              <div className="spinner-border text-primary"></div>  : null
                          }
                        </div>

                        <div className="my-4">
                          <div style={{scrollMarginTop:"160px"}} id="root-cause-analysis" className="w-100 d-inline-flex">
                            <h4>Root Cause Analysis</h4>
                            {!enableEdit  && rcaId?
                                null : <i className="bx bx-plus-circle text-primary font-size-20 ms-2"
                                          style={{marginTop: "2px"}}
                                          onClick={() => {
                                            let index = questions.length;
                                            addQuestion(index);
                                          }}/>
                            }
                          </div>
                          <div className="d-flex gap-2 align-items-center my-2 justify-content-between">
                          </div>
                          {isLoading2 ? (
                              <div className="spinner-border text-primary"></div>
                          ) : (
                          questions?.map((item, index) => (
                              <div key={index}>
                                <div className="d-flex align-items-center w-100">
                                  <div className="position-relative" style={{ width: "60px", height: "100px" }}>
                                    <div className="h-100 position-absolute d-flex align-items-center"
                                         style={{
                                           width: "60px",
                                           height: "50%",
                                           borderBottomLeftRadius: "5px",
                                           backgroundColor: "transparent" ,
                                           alignItems:"center",
                                         }}>
                                          <span style={{
                                            position: "absolute",
                                            left: 0,
                                            bottom: 0,
                                            top:"20%",
                                            width: "100%",
                                            height: "50%",
                                            borderLeft: "2px solid white",
                                            borderBottom: "2px solid white",
                                            borderBottomLeftRadius: "5px",
                                          }}>
                                          </span>
                                    </div>
                                  </div>
                                  <div className="d-flex flex-column gap-3 w-100">
                                    <div className="d-flex gap-2" style={{width: "75%"}}>
                                      <span>Why</span>
                                      {isEditable.questions || enableEdit ?
                                          <input
                                              className="input w-75"
                                              onChange={(e) => handleInputChange(index, 'question', e.target.value, 'questions')}
                                              value={item.question}
                                              placeholder="Enter question"
                                              type="text">
                                          </input>
                                          :
                                          <div className="input w-100">{item?.question}</div>
                                      }
                                    </div>
                                    <div className="d-flex gap-2 ms-5" style={{width: "84%"}}>
                                      <span>Because</span>
                                      {isEditable.questions || enableEdit ?
                                          <input
                                              className="input w-100"
                                              onChange={(e) => handleInputChange(index, 'response', e.target.value, 'questions')}
                                              value={item.response}
                                              placeholder="Enter response">
                                          </input>
                                          :
                                          <div className="input w-100">{item?.response}</div>
                                      }
                                    </div>
                                  </div>
                                  {isEditable.questions || enableEdit ?
                                      <span style={{width:"10%"}} role="button" onClick={() => removeItem(index, "questions")}>
                                    <i className="mdi mdi-delete font-size-18 text-danger pb-5"></i>
                                </span>
                                      : null
                                  }
                                </div>
                              </div>
                          ))
                          )}
                          {(questions.length === 0 && (!rca_by_id?.questions || rca_by_id?.questions.length === 0)) ?
                              <div className="d-flex align-items-center justify-content-center font-size-13 text-white" style={{width:"90%"}}>No root cause added</div> : null
                          }
                          {loading.questions ?
                              <div className="spinner-border text-primary"></div>  : null
                          }
                        </div>

                        <div>
                          <div style={{scrollMarginTop: "160px"}} id="action-items" className="w-100 d-inline-block justify-content-between my-1">
                            <div className="d-inline-flex">
                              <div><h4>Action Items</h4></div>
                                {!enableEdit && rcaId ?
                                    null :<i className="bx bx-plus-circle text-primary font-size-20 ms-2" style={{marginTop: "2px"}}
                                   onClick={() => {
                                     addNewCard()
                                     }}/>
                                }
                            </div>
                            <div className="mx-1" style={{width: "90%"}}>
                              {!enableEdit  && rcaId ?
                                <React.Fragment>
                                    <CardHeader>
                                      <Row style={{ alignContent: "center" }}>
                                        <Col className="text-center resource-name-truncate" md="4">Title</Col>
                                        <Col className="text-center" md="2">Action Type</Col>
                                        <Col className="text-center" md="2">Target Date</Col>
                                        <Col className="text-center" md="2">Assigned To</Col>
                                        <Col className="text-center" md="2">Status</Col>
                                      </Row>
                                    </CardHeader>
                                    {actionItems.all.map((item, index) => (
                                        <CardItem key={index}>
                                          <div>
                                            <Row>
                                              <Col className="resource-name-truncate text-center" md="4">
                                                <Link to={`/RCA?tab=ActionItems&actionItemId=${item.rca_action_id}`}>
                                                  {item?.title}
                                                </Link>
                                              </Col>
                                              <Col className="resource-name-truncate text-center" md="2">
                                                {item?.label}
                                              </Col>
                                              <Col className="resource-name-truncate text-center" md="2">
                                                {getDate(item.target_date)}
                                              </Col>
                                              <Col className="resource-name-truncate text-center" md="2">
                                                {allUsers[item?.assigned_to]?.name}
                                              </Col>
                                              <Col className="resource-name-truncate text-center" md="2">
                                                {item?.status || "Pending"}
                                              </Col>
                                            </Row>
                                          </div>
                                        </CardItem>
                                    ))}
                                  </React.Fragment> : null
                              }
                              {enableEdit &&
                                <div className="w-100">
                                {actionItem?.map((item, index) => (
                                    <div
                                        key={index}
                                        className="card mb-3 p-3"
                                        style={{
                                          backgroundColor: "transparent",
                                          border: "solid 1px",
                                          borderColor: '#2d213d'
                                        }}
                                    >
                                      <div className="d-flex flex-column">
                                        <div
                                          className="d-flex justify-content-between align-items-center mb-3">
                                          <h5>Action Item {index + 1}</h5>
                                          <span role="button" onClick={() => removeActionItemCard(index)}>
                                            <i className="mdi mdi-delete font-size-20 text-danger"/>
                                          </span>
                                        </div>
                                        <div className="d-flex w-100 mb-3 gap-3">
                                          <div className="w-50">
                                            <label className="text-white">Task</label>
                                            <input
                                                className="input mb-2 text-white w-100"
                                                // style={{borderColor: '#485EC4'}}
                                                placeholder="Enter title"
                                                style={{minHeight:"39px"}}
                                                value={item.title}
                                                onChange={(e) => updateActionItemCard(index, 'title', e.target.value)
                                                }
                                            />
                                          </div>
                                          <div className="w-50">
                                            <div className="d-flex w-100 mb-3 gap-3">
                                              <div className="w-50">
                                                <label className="text-white">Due date</label>
                                                <input
                                                    type="date"
                                                    className="input w-100 text-white"
                                                    style={{minHeight:"39px"}}
                                                    value={item.target_date ? new Date(item.target_date).toISOString().split('T')[0] : ''}
                                                    onChange={(e) => updateActionItemCard(index, 'target_date', e.target.value)}
                                                />
                                              </div>
                                              <div className="w-50">
                                                <label className="text-white">Assigned To</label>
                                                <Select
                                                    isClearable
                                                    className="w-100 text-white"
                                                    style={{minHeight:"39px"}}
                                                    placeholder="Search: User"
                                                    value={item.assigned_to ? {
                                                      label: allUsers[item.assigned_to].name,
                                                      value: allUsers[item.assigned_to].id
                                                    } : null}
                                                    onChange={(selectedOption) => {
                                                      setAssignedUsers(prev => ({
                                                        ...prev,
                                                        [index]: {
                                                          name: selectedOption.label,
                                                          id: selectedOption.value
                                                        }
                                                      }));
                                                      updateActionItemCard(index, 'assigned_to', selectedOption.value);
                                                    }}
                                                    options={filteredUsers1.map(([id, user]) => ({
                                                      value: id,
                                                      label: user.name
                                                    }))}
                                                    onInputChange={(searchQuery) => setSearchQueryUser(searchQuery)}
                                                    onFocus={() => setActiveDropdownId(index)}
                                                    onBlur={() => {
                                                      setTimeout(() => setActiveDropdownId(null), 200);
                                                    }}
                                                    theme={(theme) => ({
                                                      ...theme,
                                                      borderRadius: 0,
                                                      colors: {
                                                        ...theme.colors,
                                                        neutral0: '#ffffff',
                                                        neutral5: '#ffffff',
                                                        neutral10: '#ffffff',
                                                        neutral60: '#ffffff',
                                                        neutral70: '#ffffff',
                                                        neutral80: '#ffffff',
                                                        neutral90: '#ffffff',
                                                        primary: '#485EC4',
                                                      },
                                                    })}
                                                    styles={customStyles}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="d-flex w-100 mb-3 gap-3">
                                            <div className="w-50">
                                              <label className="text-white">Description</label>
                                              <textarea
                                                  className="w-100 input text-white"
                                                  style={{minHeight:"39px",paddingTop:"3px",paddingBottom:"0px"}}
                                                  // style={{borderColor: '#485EC4'}}
                                                  value={item.description}
                                                  onChange={(e) => updateActionItemCard(index, 'description', e.target.value)}
                                              />
                                            </div>
                                          <div className="w-50">
                                            <div className="d-flex w-100 mb-3 gap-3">
                                              <div className="w-50">
                                                <label className="text-white">Status</label>
                                                <Select
                                                    isClearable
                                                    style={{minHeight:"39px"}}
                                                    options={statusOptions1}
                                                    value={{
                                                      value: item.status,
                                                      label: statusOptions1.find(opt => opt.value === item.status)?.label
                                                    }}
                                                    placeholder="Choose status"
                                                    onChange={(selectedOption) => {
                                                      setSelectedStatuses(prev => ({
                                                        ...prev,
                                                        [index]: selectedOption
                                                      }));
                                                      updateActionItemCard(index, 'status', selectedOption?.value || '');
                                                    }}
                                                    theme={(theme) => ({
                                                      ...theme,
                                                      borderRadius: 0,
                                                      colors: {
                                                        ...theme.colors,
                                                        neutral0: '#ffffff',
                                                        neutral5: '#ffffff',
                                                        neutral10: '#ffffff',
                                                        neutral60: '#ffffff',
                                                        neutral70: '#ffffff',
                                                        neutral80: '#ffffff',
                                                        neutral90: '#ffffff',
                                                        primary: '#485EC4',
                                                      },
                                                    })}
                                                    styles={customStyles}
                                                />
                                              </div>
                                              <div className="w-50">
                                                <label className="text-white">Action Type</label>
                                                <Select
                                                    isClearable
                                                    options={labelOptions}
                                                    value={{
                                                      value: item.label,
                                                      label: labelOptions.find(opt => opt.value === item.label)?.label
                                                    }}
                                                    placeholder="Action Type"
                                                    onChange={(selectedOption) => {
                                                      setSelectedLabels(prev => ({
                                                        ...prev,
                                                        [index]: selectedOption
                                                      }));
                                                      updateActionItemCard(index, 'label', selectedOption?.value || '');
                                                    }}
                                                    theme={(theme) => ({
                                                      ...theme,
                                                      borderRadius: 0,
                                                      colors: {
                                                        ...theme.colors,
                                                        neutral0: '#ffffff',
                                                        neutral5: '#ffffff',
                                                        neutral10: '#ffffff',
                                                        neutral60: '#ffffff',
                                                        neutral70: '#ffffff',
                                                        neutral80: '#ffffff',
                                                        neutral90: '#ffffff',
                                                        primary: '#485EC4',
                                                      },
                                                    })}
                                                    styles={customStyles}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                ))}
                              </div>
                              }
                              {!openAddActionItems && actionItems.all.length === 0 && (!rca_by_id?.action_items || rca_by_id?.action_items.length === 0) ?
                                  <div
                                      className="d-flex align-items-center justify-content-center font-size-13 text-white">No
                                    Action Items Added</div> : null
                              }
                            </div>
                              <div className="d-inline-flex" style={{width:"90%"}}>
                                {openAddActionItems ? (
                                    <div className="w-100">
                                      {actionItem.map((item, index) => (
                                          <div
                                              key={index}
                                              className="card mb-3 p-3"
                                              style={{
                                                backgroundColor:"transparent",
                                                border:"solid 1px",
                                                borderColor: '#2d213d'
                                              }}
                                          >
                                            <div className="d-flex flex-column">
                                              <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5>Action Item {index + 1}</h5>
                                                <span role="button" onClick={() => removeActionItemCard(index)}>
                                                  <i className="mdi mdi-delete font-size-20 text-danger"/>
                                                </span>
                                              </div>
                                              <div className="d-flex w-100 mb-3 gap-3">
                                                <div className="w-50">
                                                  <label className="text-white">Task</label>
                                                  <input
                                                      className="input mb-2 text-white w-100"
                                                      // style={{borderColor: '#485EC4'}}
                                                      style={{minHeight:"39px"}}
                                                      id ='title'
                                                      placeholder="Enter title"
                                                      value={item.title}
                                                      onChange={(e) =>
                                                          updateActionItemCard(index, 'title', e.target.value)
                                                      }
                                                  />
                                                </div>
                                                <div className="w-50">
                                                  <div className="d-flex w-100 mb-3 gap-3">
                                                    <div className="w-50">
                                                      <label className="text-white">Due date</label>
                                                      <input
                                                          type="date"
                                                          style={{minHeight:"39px"}}
                                                          className="input w-100 text-white"
                                                          value={item.target_date}
                                                          onChange={(e) => updateActionItemCard(index, 'target_date', e.target.value)}
                                                      />
                                                    </div>
                                                    <div className="w-50">
                                                      <label className="text-white">Assigned To</label>
                                                      <Select
                                                          isClearable
                                                          style={{minHeight:"39px"}}
                                                          className="w-100 text-white"
                                                          placeholder="Search: User"
                                                          value={assignedUsers[index] ? {label: assignedUsers[index].name, value: assignedUsers[index].id} : null}
                                                          onChange={(selectedOption) => {
                                                            setAssignedUsers(prev => ({
                                                              ...prev,
                                                              [index]: {name: selectedOption.label, id: selectedOption.value}
                                                            }));
                                                            updateActionItemCard(index, 'assigned_to', selectedOption.value);
                                                          }}
                                                          options={filteredUsers1.map(([id, user]) => ({value: id, label: user.name}))}
                                                          onInputChange={(searchQuery) => setSearchQueryUser(searchQuery)}
                                                          onFocus={() => setActiveDropdownId(index)}
                                                          onBlur={() => {
                                                            setTimeout(() => setActiveDropdownId(null), 200);
                                                          }}
                                                          theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                              ...theme.colors,
                                                              neutral0: '#ffffff',
                                                              neutral5: '#ffffff',
                                                              neutral10: '#ffffff',
                                                              neutral60: '#ffffff',
                                                              neutral70: '#ffffff',
                                                              neutral80: '#ffffff',
                                                              neutral90: '#ffffff',
                                                              primary: '#485EC4',
                                                            },
                                                          })}
                                                          styles={customStyles}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="d-flex w-100 mb-3 gap-3">
                                                <div className="w-50">
                                                  <div className="w-100">
                                                    <label className="text-white">Description</label>
                                                    <textarea
                                                        className="w-100 input text-white match-height"
                                                        // style={{borderColor: '#485EC4'}}
                                                        style={{minHeight:"35px",paddingTop:"3px",paddingBottom:"0px"}}
                                                        value={item.description}
                                                        onChange={(e) => updateActionItemCard(index, 'description', e.target.value)}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="w-50">
                                                  <div className="d-flex w-100 mb-3 gap-3">
                                                    <div className="w-50">
                                                      <label className="text-white">Status</label>
                                                      <Select
                                                          isClearable
                                                          style={{minHeight:"39px"}}
                                                          options={statusOptions1}
                                                          value={selectedStatuses[index] || null}
                                                          placeholder="Choose status"
                                                          onChange={(selectedOption) => {
                                                            setSelectedStatuses(prev => ({
                                                              ...prev,
                                                              [index]: selectedOption
                                                            }));
                                                            updateActionItemCard(index, 'status', selectedOption?.value || '');
                                                          }}
                                                          theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                              ...theme.colors,
                                                              neutral0: '#ffffff',
                                                              neutral5: '#ffffff',
                                                              neutral10: '#ffffff',
                                                              neutral60: '#ffffff',
                                                              neutral70: '#ffffff',
                                                              neutral80: '#ffffff',
                                                              neutral90: '#ffffff',
                                                              primary: '#485EC4',
                                                            },
                                                          })}
                                                          styles={customStyles}
                                                      />
                                                    </div>
                                                    <div className="w-50">
                                                      <label className="text-white">Action Type</label>
                                                      <Select
                                                          isClearable
                                                          options={labelOptions}
                                                          style={{minHeight:"39px"}}
                                                          value={selectedLabels[index] || null}
                                                          placeholder="Action Type"
                                                          onChange={(selectedOption) => {
                                                            setSelectedLabels(prev => ({
                                                              ...prev,
                                                              [index]: selectedOption
                                                            }));
                                                            updateActionItemCard(index, 'label', selectedOption?.value || '');
                                                          }}
                                                          theme={(theme) => ({
                                                            ...theme,
                                                            borderRadius: 0,
                                                            colors: {
                                                              ...theme.colors,
                                                              neutral0: '#ffffff',
                                                              neutral5: '#ffffff',
                                                              neutral10: '#ffffff',
                                                              neutral60: '#ffffff',
                                                              neutral70: '#ffffff',
                                                              neutral80: '#ffffff',
                                                              neutral90: '#ffffff',
                                                              primary: '#485EC4',
                                                            },
                                                          })}
                                                          styles={customStyles}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      }
                                    </div>) : null}
                              </div>
                            </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={deleteConfirmationModalIsOpen} toggle={toggleModal} centered>
          <ModalHeader className="text-white justify-content-center d-flex">
            Confirm Deletion
          </ModalHeader>
          <ModalBody className="text-center">
            <p className="mb-4">
              Are you sure you want to delete this RCA? <br/>
              <strong>All data associated with this RCA will be lost.</strong>
            </p>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-center">
            <button className="btn btn-outline-secondary mx-2" onClick={toggleModal}>
              Cancel
            </button>
            <button className="btn btn-danger mx-2" onClick={handleDelete}>
              Delete
            </button>
          </ModalFooter>
        </Modal>
        <ShareModal isOpen={shareModalIsOpen} toggle={toggleShareModal} allUsers={allUsers}
                    rcaName={rca_by_id?.rca?.title}/>
      </React.Fragment>
  )
}

export default RcaForm;